import { Box, TextNew } from '@jfs/ui-new'
import { isEmpty } from '@jfs/ui-new/src/utils/utils'
import { getErrorMessage } from '@jfs/utils'
import { FC, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import EmptyView from '../../comps/EmptyView'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { useLazyApiData, useStores } from '../../data/store'
import { getBase64Image } from '../../util/util'
import { QRCodeView } from './QRCodeView'
import { styles } from './styles'
import { TopActionButton } from './TopActionButton'

interface UpiQRCodeInterface {}

const UpiQRCode: FC = ({}: UpiQRCodeInterface) => {
  const [qrData, updateQrdata] = useState({ staticQr: '', vpa: '' })
  const [downloadingQr, updateDownloadQrLoader] = useState(false)

  const qrgeneratedMid = useRef('')
  const { fetchQrCode, mid, downloadAllInOneQr, qrAndVpaData, merchantName, vpa } = useStores((root) => ({
    fetchQrCode: root.user.getQrCode,
    mid: root.user.selectedMid,
    downloadAllInOneQr: root.user.downloadAllInOneQr,
    qrAndVpaData: root.settings.metaData.merchantQrAndVpa(),
    merchantName: root.settings.metaData.selectedMercLegalName,
    vpa: root.settings.metaData.vpa,
  }))

  const [fetchQr, fetchQrHandler] = useLazyApiData(fetchQrCode)
  const [donwloadQr, donwloadHandler] = useLazyApiData(downloadAllInOneQr)
  const loading = fetchQrHandler.state === 'pending'

  const apis = useMemo(() => [fetchQrHandler], [fetchQrHandler])
  const errorState = useMemo(() => getErrorMessage(apis), [apis])

  const isQrValid = fetchQrHandler.state !== 'rejected'

  useLayoutEffect(() => {
    if (mid.length > 0) {
      if (isEmpty(qrAndVpaData?.staticQr) || mid !== qrgeneratedMid.current) {
        fetchQr()
        qrgeneratedMid.current = mid
      } else {
        const QR = getBase64Image(qrAndVpaData?.staticQr)
        const storeQrData = {
          staticQr: QR,
          vpa: qrAndVpaData?.vpa,
        }
        updateQrdata(storeQrData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchQr, mid, vpa])

  const onRetry = useCallback(() => {
    fetchQr()
  }, [fetchQr])

  const { state, data } = fetchQrHandler
  useEffect(() => {
    if (state === 'fulfilled') {
      const QR = getBase64Image(data?.qr)
      const apiData = {
        staticQr: QR,
        vpa: data?.vpa,
      }
      updateQrdata(apiData)
    }
  }, [state])

  useEffect(() => {
    if (donwloadHandler?.state === 'fulfilled') {
      updateDownloadQrLoader(false)
    } else if (donwloadHandler?.state === 'rejected') {
      updateDownloadQrLoader(false)
    }
  }, [donwloadHandler])

  const downloadQR = useCallback(() => {
    if (mid && mid.length > 0 && qrData && isQrValid) {
      updateDownloadQrLoader(true)
      donwloadQr('', '')
    }
  }, [donwloadQr, isQrValid, mid, qrData])

  return (
    <Box {...styles.container}>
      <Box {...styles.flexRowView}>
        <TextNew title={'UPI QR code'} {...styles.titleText} />
        <TopActionButton loading={loading} downloadQR={downloadQR} downloadingQr={downloadingQr} isValid={isQrValid} />
      </Box>
      <EmptyView
        onRetry={onRetry}
        isLoading={loading}
        error={errorState}
        emptyMessage={qrData?.staticQr ? '' : 'No QR Found Found...'}
        loadingMessage={''}
        hide={!errorState && !loading && qrData?.staticQr}
        loaderColor={'BLUE'}
      />
      <ModBox {...styles.qrMainView()} show={!loading && !errorState}>
        <QRCodeView loading={loading} qrImage={qrData?.staticQr} vpa={qrData?.vpa} merchantName={merchantName} />
      </ModBox>
    </Box>
  )
}

export default UpiQRCode
